// HumanityClub
import React from 'react';
import HumanityClub from 'views/HumanityAssociation';

const HumanityClubPage = () => {
  return <HumanityClub />;
};

export default HumanityClubPage;
